import type { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import type { ExcelTemplateSideGuide } from 'src/utils/excel/excelGridConfig';

/** 신규 BOM 행과 Excel 예시에서 사용하는 자재공급방법 기본 코드 */
export const MST1020_R01_DEFAULT_MATERIAL_INTYPE = 'PURCHASE';

/** 기존 템플릿의 규격·보관위치 열까지 호환하기 위한 업로드 영역 A:R의 열 개수 */
export const MST1020_R01_EXCEL_UPLOAD_COLUMN_COUNT = 18;

/** 데이터 영역(A:R)과 구분 열(S)을 지나 안내표가 시작되는 T열의 0 기반 인덱스 */
const MST1020_R01_MATERIAL_INTYPE_GUIDE_START_COLUMN = 19;

/**
 * 자재공급방법 공통코드를 Excel 템플릿 우측 안내표 형식으로 변환한다.
 * 빈 코드는 제외하고 화면 표시 순서대로 정렬하며 기본 코드에는 별도 표시를 추가한다.
 */
export const createMST1020_R01MaterialIntypeGuide = (
	materialIntypeList: SysCodeDto[]
): ExcelTemplateSideGuide => ({
	startColumn: MST1020_R01_MATERIAL_INTYPE_GUIDE_START_COLUMN,
	title: '자재공급방법 코드 안내',
	description: '자재공급방법 열에는 아래 코드값 중 하나를 입력하세요.',
	headers: ['코드값', '코드명', '비고'],
	rows: [...materialIntypeList]
		// 공통코드에 유효한 코드값이 없는 행은 템플릿 안내 대상에서 제외한다.
		.filter((code) => Boolean(code.minorCd))
		// 공통코드 관리 화면의 표시 순서를 Excel 안내표에도 동일하게 적용한다.
		.sort((a, b) => a.dispSeq - b.dispSeq)
		.map((code) => [
			code.minorCd,
			code.codeNm || '',
			// 사용자가 별도 문의 없이 기본 입력값을 구분할 수 있도록 표시한다.
			code.minorCd === MST1020_R01_DEFAULT_MATERIAL_INTYPE ? '기본값' : '',
		]),
	colWidths: [18, 24, 12],
});
